export function isIn<Value extends string | number | null | undefined, Values extends readonly Value[]>(
  value: Value,
  values: Values
): value is Values[number] {
  return (values as readonly unknown[]).includes(value);
}
